__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "aurora";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("next/dynamic", "15.1.9", () => (__webpack_require__.e(56749).then(() => (() => (__webpack_require__(56749))))));
			register("next/head", "15.1.9", () => (__webpack_require__.e(71756).then(() => (() => (__webpack_require__(71756))))));
			register("next/image", "15.1.9", () => (Promise.all([__webpack_require__.e(88209), __webpack_require__.e(85714), __webpack_require__.e(81562)]).then(() => (() => (__webpack_require__(88209))))));
			register("next/link", "15.1.9", () => (Promise.all([__webpack_require__.e(19901), __webpack_require__.e(95270)]).then(() => (() => (__webpack_require__(95270))))));
			register("next/router", "15.1.9", () => (Promise.all([__webpack_require__.e(19901), __webpack_require__.e(72831), __webpack_require__.e(85714), __webpack_require__.e(32966)]).then(() => (() => (__webpack_require__(72831))))));
			register("next/script", "15.1.9", () => (Promise.all([__webpack_require__.e(85714), __webpack_require__.e(44545)]).then(() => (() => (__webpack_require__(44545))))));
			register("react-dom/client", "18.2.0", () => (Promise.all([__webpack_require__.e(46593), __webpack_require__.e(85714)]).then(() => (() => (__webpack_require__(7470))))));
			register("react-dom", "18.2.0", () => (__webpack_require__.e(46593).then(() => (() => (__webpack_require__(78325))))));
			register("react/jsx-runtime", "18.2.0", () => (__webpack_require__.e(46593).then(() => (() => (__webpack_require__(62540))))));
			register("react", "18.2.0", () => (__webpack_require__.e(46593).then(() => (() => (__webpack_require__(63696))))));
			register("styled-jsx/style", "5.1.6", () => (__webpack_require__.e(71314).then(() => (() => (__webpack_require__(71314))))));
			register("styled-jsx", "5.1.6", () => (__webpack_require__.e(17071).then(() => (() => (__webpack_require__(17071))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};